<template>
    <div class="appointment">
        <pdfs class="m-b-20 pdfs"></pdfs>
        <handwriting class="handwriting" @func="getMsgFormSon"></handwriting>
    </div>
</template>
<script>
import pdfs from '@/components/pdfs.vue'
import handwriting from '@/components/handwriting.vue'
import { setTimeout } from 'timers';
export default {
    components: {
        handwriting,
        pdfs,
    },
    data () {
      return {
      }
    },
    created(){
        
        console.log(this.$route.query.item)
    },
    methods: {
        getMsgFormSon(item){
            console.log(item);
            this.$router.push({path:'/contractList'});
        }
    }
}
</script>

<style lang="scss" scoped>
.appointment{
    position: relative;
    width: 100vw;
    height: 100%;
    .handwriting{
        width: 100vw;
        position: fixed;    
        bottom: 0;
    }
    .pdfs{
        width: 100vw;
        height: 71%;
        // overflow-y: scroll;
    }
}
</style>

